export default __webpack_public_path__ + "static/web-layout-advance-metrix-20a6af8f530fe05a2016379c5d54b3d9.png";